import React, { Component } from 'react';
import NumberFormat from 'react-number-format';
import TextInput from './TextInput';

/**
 * Returns value in cents
 * @type {{$$typeof, render}|*}
 */
const CurrencyInput = React.forwardRef(
	function CurrencyInput({ onChange, value, ...props }, ref) {

		const onValueChange = (event) => {
			if(!onChange) {
				return;
			}
			const cents = (event.value * 100).toFixed(0);
			onChange(cents);
		};

		return <NumberFormat
			{...props}
			value={(value / 100).toFixed(2)}
			getInputRef={ref}
			autoComplete='off'
			isNumericString={true}
			onValueChange={onValueChange}
			decimalScale={2}
			fixedDecimalScale={true}
			customInput={TextInput}
			defaultValue=''
		/>;
	});

export default CurrencyInput;